// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"962":"home","966":"login"}[chunkId] + "." + {"962":"ad7bcbab00fb5c7c","966":"c6fdbdf2b3e92bf7"}[chunkId] + ".js";
};